// Copyright © 2021 Move Closer
import { AbstractTheme, hasSizeProp, useSizeClass, useThemeClass } from '../../_composables';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const getAbstractButtonProps = () => ({
    ...hasSizeProp,
    /**
     * Determines whether the `<button>` should be disabled.
     */
    disabled: {
        type: Boolean,
        required: false,
        default: false
    },
    /**
     * The theme of the `<button>`.
     */
    theme: {
        type: String,
        required: false,
        default: () => AbstractTheme.Default
    }
});
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const useButton = (emit, size, sizeRegistry, theme, themeRegistry) => {
    const onClick = () => { emit('click'); };
    const sizeClass = useSizeClass(size, sizeRegistry);
    const themeClass = useThemeClass(theme, themeRegistry);
    return { onClick, sizeClass, themeClass };
};
